"use strict";

exports.__esModule = true;
exports.ActionButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _ErrorAlert = require("../ErrorAlert");
var _excluded = ["disabled", "loading", "intent", "successIntent", "text", "successText", "icon", "successIcon", "confirm", "confirmButtonText", "cancelButtonText", "successTimeout", "onClick", "onSuccess", "onError"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * A button which triggers an async action which clicked.
 * The button loading / disabled state is updated according
 * to the state of the promise returned by the `onClick` prop.
 */
var ActionButton = exports.ActionButton = /*#__PURE__*/function (_Component) {
  function ActionButton() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.successTimer = undefined;
    _this.state = {
      loading: false,
      confirming: false,
      disabled: false,
      success: false,
      error: undefined
    };
    _this.unmounted = false;
    _this.handleButtonClick = function (e) {
      var confirm = _this.props.confirm;
      if (confirm) {
        _this.setState({
          confirming: true
        });
      } else {
        _this.runAction(e);
      }
    };
    _this.handleConfirmClick = function (e) {
      _this.runAction(e);
    };
    _this.handleCancelClick = function () {
      _this.setState({
        confirming: false
      });
    };
    _this.handleSuccess = function (result) {
      if (_this.unmounted) {
        return;
      }
      var _this$props = _this.props,
        onSuccess = _this$props.onSuccess,
        successTimeout = _this$props.successTimeout;
      _this.setState({
        confirming: false,
        loading: false,
        disabled: false,
        success: true,
        error: undefined
      });
      if (_this.successTimer !== undefined) {
        clearTimeout(_this.successTimer);
      }
      _this.successTimer = setTimeout(_this.clearSuccess, successTimeout);
      if (typeof onSuccess === "function") {
        onSuccess(result);
      }
    };
    _this.handleError = function (error) {
      if (_this.unmounted) {
        return;
      }
      var onError = _this.props.onError;
      _this.setState({
        confirming: false,
        loading: false,
        disabled: false,
        success: false,
        error: error
      });
      if (typeof onError === "function") {
        onError(error);
      } else {
        console.error(error.stack || error);
      }
    };
    _this.handleErrorClick = function () {
      _this.setState({
        loading: false,
        disabled: false,
        error: undefined
      });
    };
    _this.clearSuccess = function () {
      _this.successTimer = undefined;
      if (_this.unmounted) {
        return;
      }
      _this.setState({
        success: false
      });
    };
    return _this;
  }
  _inheritsLoose(ActionButton, _Component);
  var _proto = ActionButton.prototype;
  _proto.runAction = function runAction(e) {
    var onClick = this.props.onClick;
    if (this.successTimer !== undefined) {
      clearTimeout(this.successTimer);
    }
    this.setState({
      confirming: false,
      loading: true,
      disabled: true,
      success: false
    });
    Promise.resolve(onClick(e)).then(this.handleSuccess, this.handleError);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      disabled = _this$props2.disabled,
      loading = _this$props2.loading,
      intent = _this$props2.intent,
      successIntent = _this$props2.successIntent,
      text = _this$props2.text,
      successText = _this$props2.successText,
      icon = _this$props2.icon,
      successIcon = _this$props2.successIcon,
      confirm = _this$props2.confirm,
      confirmButtonText = _this$props2.confirmButtonText,
      cancelButtonText = _this$props2.cancelButtonText,
      successTimeout = _this$props2.successTimeout,
      onClick = _this$props2.onClick,
      onSuccess = _this$props2.onSuccess,
      onError = _this$props2.onError,
      extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
    var _this$state = this.state,
      success = _this$state.success,
      error = _this$state.error,
      confirming = _this$state.confirming;
    var button = /*#__PURE__*/_react["default"].createElement(_core.Button, _extends({
      "data-testid": "ActionButton"
    }, extra, {
      key: "button",
      intent: success && successIntent || intent,
      text: success && successText || text,
      icon: success && successIcon || icon,
      loading: this.state.loading || loading,
      disabled: this.state.disabled || disabled,
      onClick: this.handleButtonClick
    }));
    var confirmAlert;
    if (confirming) {
      confirmAlert = /*#__PURE__*/_react["default"].createElement(_core.Alert, {
        key: "confirm",
        intent: intent,
        isOpen: true,
        onConfirm: this.handleConfirmClick,
        onCancel: this.handleCancelClick,
        canEscapeKeyCancel: true,
        canOutsideClickCancel: true,
        confirmButtonText: confirmButtonText || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ActionButton.confirmButtonText.ok",
          defaultMessage: "OK"
        }),
        cancelButtonText: cancelButtonText || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ActionButton.confirmButtonText.cancel",
          defaultMessage: "Cancel"
        })
      }, confirm);
    }
    var errorAlert;
    if (error !== undefined) {
      errorAlert = /*#__PURE__*/_react["default"].createElement(_ErrorAlert.ErrorAlert, {
        key: "error",
        error: error,
        isOpen: true,
        onConfirm: this.handleErrorClick
      });
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, button, confirmAlert, errorAlert);
  };
  return ActionButton;
}(_react.Component);
ActionButton.defaultProps = {
  successTimeout: 3000
};